<template>
  <div ref="popup" class="popup" :class="{ popup_mobile: isMobile }">
    <div class="popup__wrap">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.5 15.8" @click="hidePopup()" v-bind:svg-inline="''" v-bind:class="'popup__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.2 7.9l5.3 5.3c.4.4.4 1 0 1.4s-1 .4-1.4 0L7.8 9.3l-5.3 5.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l5.3-5.3-5.3-5.3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l5.3 5.3 5.3-5.3c.4-.4 1-.4 1.4 0s.4 1 0 1.4L9.2 7.9z"/></svg>

      <div class="popup__req">Необходимо заполнить все поля.</div>

      <div class="feedback">
        <input
          v-model="name"
          :class="{ feedback__inp_err: !nameErr}"
          class="feedback__inp"
          type="text"
          placeholder="Имя">
        <input
          v-model="email"
          :class="{ feedback__inp_err: !emailErr}"
          class="feedback__inp"
          type="text"
          placeholder="Email">
        <input
          v-model="topic"
          :class="{ feedback__inp_err: !topicErr}"
          class="feedback__inp"
          type="text"
          placeholder="Тема">
        <textarea
          :class="{ feedback__inp_err: !messageErr}"
          v-model="message"
          class="feedback__inp feedback__inp_textarea"
          placeholder="Сообщение">
        </textarea>
        <div
          @click="sendFeedback()"
          class="feedback__btn">Отправить</div>
      </div>

      <div class="popup__success">
        Спасибо за обращение!
        <br>
        Мы свяжемся с вами в ближайшее время!</div>
      <div class="popup__err">Что-то пошло не так :(</div>
      <a class="popup__phone-link" href="tel:+74952270644">
        <span>+7 (495) 227 06 44</span>
      </a>
    </div>
  </div>
</template>

<script>
import { isMobile } from 'mobile-device-detect';
import Axios from 'axios';

export default {
  name: 'feedback',
  props: {
    showPopup: {
      type: Boolean,
    },
  },
  data() {
    return {
      isMobile,
      name: '',
      email: '',
      topic: '',
      message: '',
      nameErr: true,
      emailErr: true,
      topicErr: true,
      messageErr: true,
    };
  },
  methods: {
    clearFormData() {
      this.name = '';
      this.email = '';
      this.topic = '';
      this.message = '';
    },
    sendFeedback() {
      this.validEmail();
      this.validName();
      this.validTopic();
      this.validMessage();
      if (this.nameErr && this.topicErr && this.messageErr && this.emailErr) {
        Axios
          .post('https://api.buzzoola.com/feedback', null, {
            params: {
              name: this.name,
              email: this.email,
              topic: this.topic,
              message: this.message,
            },
          })
          .then((response) => {
            // eslint-disable-next-line
            console.log(response);
            this.clearFormData();
            this.$refs.popup.classList.add('popup_success');
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
            this.$refs.popup.classList.add('popup_err');
          });
      }
    },
    validEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.emailErr = re.test(this.email) === true;
    },
    validName() {
      this.nameErr = this.name.length > 0;
    },
    validTopic() {
      this.topicErr = this.topic.length > 0;
    },
    validMessage() {
      this.messageErr = this.message.length > 0;
    },
    hidePopup() {
      this.$emit('hidePopup');
    },
  },
};
</script>

<style scoped lang='stylus'>

hover()
  @media (hover: hover)
    {block}

.feedback
  width 100%
  .popup_success &
    display none
  &__inp
    display block
    width 100%
    margin-bottom 20px
    padding 12px
    text-align left
    text-decoration none
    font-size 14px
    line-height 16px
    font-family 'Roboto', sans-serif
    font-weight 500
    color #000
    border-radius 8px
    border 1px solid #cfdae6
    box-sizing border-box
    -webkit-tap-highlight-color transparent
    outline none
    box-shadow none
    &::placeholder
      color #5d6a77
      font-family 'Roboto', sans-serif
      font-size 14px
      line-height 16px
    &:focus
      border 1px solid #f50
      outline none
      box-shadow none
    &:focus::placeholder
      color transparent
    &_err
      background-color rgba(#f50, .4)
      border-color rgba(#f50, .4)
      &::placeholder
        color #fff
    +hover()
      &:hover
        border 1px solid #f50
    &_textarea
      max-width 100%
      min-height 200px
  &__btn
    display block
    width 100%
    max-width 300px
    margin 20px auto
    padding 12px
    text-align center
    text-decoration none
    font-size 14px
    line-height 16px
    font-family 'Roboto', sans-serif
    font-weight 700
    color #f50
    border-radius 8px
    border 1px solid #cfdae6
    box-sizing border-box
    -webkit-tap-highlight-color transparent
    ^[0]_mobile &
      width calc(100% - 40px)
    +hover()
      &:hover
        background-color #f50
        color #fff
        cursor pointer
        border 1px solid #f50

.popup
  position fixed
  left 0
  top 0
  width 100%
  height 100%
  background-color rgba(#cfdae6, 0.98)
  z-index 999999999999
  &__success
    display none
    margin 40px 0
    text-align center
    color #ff5502
    font-weight bold
    font-size 20px
    line-height 25px
    ^[0]_success &
      display block
  &__err
    display none
    text-align center
    color #f50
    margin 20px
    font-weight bold
    ^[0]_err &
      display block
  &__req
    display none
    text-align center
    color #f50
    margin 20px
    font-weight bold
    ^[0]_req &
      display block
  &__phone-link
    position absolute
    left 0
    bottom 20px
    width 100%
    text-align center
    color #f50
    font-weight bold
    text-decoration none
    outline none
  &__wrap
    position relative
    width 100%
    max-width 600px
    height auto
    padding 50px 50px 50px
    margin 5% auto 0
    background-color white
    color black
    font-size 16px
    line-height 20px
    box-sizing border-box
    ^[0]_mobile &
      height 100%
      padding 60px 20px 50px
      overflow auto
      margin 0
  &__data
    &-link
      color #f50
      font-size 18px
      line-height 20px
  &__icon
    position absolute
    right 20px
    top 20px
    width 20px
    height 20px
    cursor pointer
    outline none
    fill #cfdae6
    +hover()
      &:hover
        fill #f50
</style>
